import Vue from 'vue'
import VueTheMask from 'vue-the-mask'
import VueCookies from 'vue-js-cookie'
import VueCookie from 'vue-cookie'

export default () => {
  Vue.use(VueCookie)
  Vue.use(VueCookies)
  Vue.use(VueTheMask)
}
